<template>
  <div>
    <template v-if="!item.children">
      <el-menu-item :index="item.path" :route="item.path">
        <svg-icon :name="item.meta.icon" class="icon" />
        <span>{{ item.meta.title }}</span>
      </el-menu-item>
    </template>
    <el-sub-menu :index="item.path" v-else>
      <template #title>
        <svg-icon :name="item.meta.icon" class="icon" />
        <span>{{ item.meta.title }}</span>
      </template>
      <el-menu-item v-for="list in item.children" v-show="!list.hidden" :route="list.path" :index="list.path">
        <span :class="props.currentPath === list.path ? 'item-color' : ''">{{ list.meta.title }}</span>
        </el-menu-item>
    </el-sub-menu>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
const router = useRouter()

const props = defineProps({
  // route object
  item: {
    type: Object,
    required: true
  },
  currentPath: {
    type: String
  }
})


</script>

<style lang="scss" scoped>
.el-menu-item,
.el-sub-menu {
  .icon {
    width: 14px;
    height: 14px;
    margin-right: 16px;
    color: rgba(191, 203, 217);
  }
}

.el-sub-menu {
  .el-menu-item {
    margin-left: 16px;
    letter-spacing: -1px;
  }
}

.item-color {
  color: $primary-color;
}
</style>
